<template>
  <div class="modellist-container">
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='tableLoading'>
      <el-table-column :label="$t('manage.name5')" prop="username" sortable></el-table-column>
      <el-table-column :label="$t('bike.name439')" prop="clientid" sortable width="170"> </el-table-column>
      <el-table-column :label="$t('bike.name29')" prop="created_at" sortable></el-table-column>
      <el-table-column :label="$t('bike.name440')" prop="subscriptions_cnt" sortable></el-table-column>
      <el-table-column :label="$t('bike.name441')" prop="ip_address" sortable></el-table-column>
      <el-table-column :label="$t('bike.name442')" prop="connected" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.connected  ? $t('bike.name443') : $t('bike.name444') }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { findOnlineIotPage } from '@/api/bike.js'
export default {
  data() {
    return {
      queryInfo: {
        pageNumber: 1,
        pageSize: 10
      },
      tableLoading: false,
      tableList: [],
      total: 0
    }
  },
  created() {},
  mounted() {
    this.getDataList()
  },
  computed: {},
  methods: {
    getDataList() {
      this.tableLoading = true
      findOnlineIotPage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.onlineIotPage.records
          this.total = res.data.onlineIotPage.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getDataList()
    }
  }
}
</script>
<style lang="scss" scoped>
.modellist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .upload-layout {
    display: flex;
    flex-direction: row;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
    }
    > :last-child {
      margin-left: 10px;
      font-size: 12px;
      color: #555;
      line-height: 16.8px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 178px;
  height: 178px;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
